export default __webpack_public_path__ + "static/media/call_back.0499db83.png";